import './partPage.scss';

import React, { useState } from 'react';

import { AddToCartButton } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/AddToCartButton';
import Breadcrumb from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives/Breadcrumb';
import GatsbyImageWrapper from '../components/GatsbyImageWrapper';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import LocalePrice from '@progymedia/gatsby-theme-boutik-ecommerce/src/utils/LocalePrice';
import QtyInput from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/QtyInput/QtyInput';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useProductPrice } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/store/queries/useProductsPriceAndInventories';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query ($code: String!) {
        productsJson(code: { eq: $code }) {
            id
            code
            title {
                en_CA
                en_US
                fr_CA
            }
            description {
                en_CA
                en_US
                fr_CA
                valuesMarkdownRemark {
                    en_US
                    en_CA
                    fr_CA
                }
            }
            fields {
                ...productsFieldsImagesFragment
            }
            attributes {
                meta_title {
                    values {
                        en_CA
                        en_US
                        fr_CA
                    }
                }
            }
        }
    }
`;

export default function PartPage({ data }) {
    const { currentLocale } = usePageLocalization();

    const { t } = useTranslation('pages');

    const part = data?.productsJson;

    const [price] = useProductPrice(part?.code!);
    const [requestedQuantity, setRequestedQuantity] = useState<number>(1);

    const metaTitle =
        part?.attributes?.meta_title?.values?.[0]?.[currentLocale];

    return (
        <Layout>
            <SEO
                title={t('metadata:PartPage.title', { SKU: part?.code })}
                description={
                    t('metadata:PartPage.description', {
                        SKU: part?.code,
                        TITLE: part?.title?.[currentLocale],
                    }) as string
                }
            />
            <div className='container'>
                <div className='part-page'>
                    <Breadcrumb
                        elements={[
                            {
                                name: t('archives.title'),
                                link: '/archives/',
                            },
                            {
                                name: part?.code!,
                                link: '',
                            },
                        ]}
                        separator={'>'}
                    />

                    <div className='part-infos'>
                        <div className='left'>
                            <h1 className='part-title'>
                                <span className='code'>{part?.code}</span>
                                <br />
                                <span>{part?.title?.[currentLocale]}</span>
                            </h1>

                            <div
                                className='description'
                                dangerouslySetInnerHTML={{
                                    __html:
                                        part?.description
                                            ?.valuesMarkdownRemark?.[
                                            currentLocale
                                        ] ?? '',
                                }}
                            />

                            <div className='price'>
                                <span>
                                    {price?.regularPrice?.value === 0
                                        ? '--'
                                        : LocalePrice(
                                              currentLocale,
                                              price?.regularPrice?.value
                                          )}
                                </span>
                            </div>

                            <div className='add-to-cart'>
                                <QtyInput
                                    product={part}
                                    qtyValue={requestedQuantity}
                                    setQtyValue={setRequestedQuantity}
                                />
                                <AddToCartButton
                                    className='add-to-cart-button'
                                    product={part}
                                    qty={requestedQuantity}
                                />
                            </div>
                        </div>

                        <div className='right'>
                            <GatsbyImageWrapper fields={part?.fields} />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
